import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
//import Lead from "./Lead";
import ClientLink from "./client-link";
import "flatpickr/dist/themes/material_blue.css"
import Select from "react-select"
import { Formik, Field, Form, ErrorMessage } from "formik";
import { getClientDetail, updateHomePref, postHomePref} from "../../store/clients/actions"

import * as Yup from "yup";
import axios from "axios"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  InputGroup,
  OffcanvasHeader,
  OffcanvasBody,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Toast
} from "reactstrap"
import { AvField, AvForm, AvCheckbox } from "availity-reactstrap-validation"
import ClientSidebar from "components/VerticalLayout/ClientSidebar";
import ClientBuyerBreadcrumbs from "components/Common/ClientBuyerBreadcrumb";
import ClientBuyerMenu from "./menu/client-buyer-menu";
import NoAccess from "components/NoAccess";
import { API_URL } from "helpers/app_url";
import { ToastContainer } from "react-toastify";
import CurrencyFormat from "react-currency-format";


class ClientHomePref extends Component {
  constructor(props) {
    super(props)
    this.state = {
        selectedGroup: null,
        homeprefrences: [],
        importantDestinations:[]
    }
    this.handleSelectGroup = this.handleSelectGroup.bind(this)
    this.handleHomePrefSubmit = this.handleHomePrefSubmit.bind(this)
  }
  handleSelectGroup = selectedGroup => {
    this.setState({ selectedGroup })
  }
  componentDidMount() {
    const { match: { params },onGetClientDetail} = this.props;
    onGetClientDetail(params.clientId);
    this.fetchAddHomePref();
    this.fetchImportantDest();
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
    const str = 'Bearer ' + token;
      axios.get(`${API_URL}ClientStandardHomePreference/all/?clientId=${this.props.match.params.clientId}`, {
        headers: { Authorization: str }
      })
        .then(res => {
          const homeprefrences = res.data;
          this.setState({ homeprefrences });
        })
}
handleHomePrefSubmit(value){
  const payload = {
    id:value.id,
    clientStandardHomePreferenceId:value.clientStandardHomePreferenceId,
    typeOfHouse:value.typeOfHouse,
    minPrice:parseInt(value.minPrice),
    maxPrice:parseInt(value.maxPrice),
    sqFeets:value.sqFeets,
    bedRoom:value.bedRoom,
    bathRoom:value.bathRoom,
    clientId:parseInt(value.clientId),
    clientGuid:value.clientGuid,
    city:value.city,
    preferenceDescription:value.preferenceDescription,
    agentId:parseInt(localStorage.getItem('userId'))
  }
  if (value.id > 0) {
    this.props.updateHomePref(payload, this.props.history);
  } else {
  
    this.props.postHomePref(payload, this.props.history);
  }
}
fetchAddHomePref(){
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj?.resultData?.bearerToken;
  const headers = {
      Authorization: `Bearer ${token}`, 
      "Content-Type": "application/json",
    };

    const params = {
      clientId: this.props.match.params.clientId,
      agentId:parseInt(localStorage.getItem('userId'))
    };
    axios
    .get(`${API_URL}ClientAdditionalHomePreference/all/`, { headers, params })
    .then((response) => {
      this.setState({ addprefrences: response.data, loading: false });
    })
    .catch((error) => {
      this.setState({ error: error.message, loading: false });
    });
}

fetchImportantDest(){
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj?.resultData?.bearerToken;
  const headers = {
      Authorization: `Bearer ${token}`, 
      "Content-Type": "application/json",
    };

    const params = {
      clientId: this.props.match.params.id,
      agentId: localStorage.getItem('userId')
    };
    axios
    .get(`${API_URL}ClientBuyerImportantDestinationExt/byclient`, { headers, params })
    .then((response) => {
      this.setState({ importantDestinations: response.data, loading: false });
    })
    .catch((error) => {
      this.setState({ error: error.message, loading: false });
    });
}
  render() {
    const { selectedGroup, homeprefrences } = this.state
    const { clietDetail, userdetail, isResponsive } = this.props;
    const hasBuyerType = clietDetail.clientTypes && clietDetail.clientTypes.some((type) => type.clientTypeCode === 1);
    return (
      <React.Fragment>
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Client Dashboard | Realty Space</title>
          </MetaTags>
          <ToastContainer autoClose={2000} />
          <Container fluid className="ps-0">
          {hasBuyerType ? (
            <Row>
              <Col sm='2' className="pe-0">
                <ClientSidebar id={this.props.match.params.id} clientId={this.props.match.params.clientId} clientDetail={clietDetail} isResponsive={isResponsive} />
              </Col>
              <Col sm='10' className="">
              <Row className="project-header">
                <Col sm="7">
             <ClientBuyerBreadcrumbs
              title={this.props.t("Clients")}
              breadcrumbItem={this.props.t( "Home Preferences")}
            />
            </Col>
            <Col sm="4" className="">
                <h2 className="">{this.props.t( clietDetail.firstName + " " + clietDetail.lastName)}</h2>
                </Col>
            </Row>
            <ClientBuyerMenu isResponsive={isResponsive} />
            <Row>
            {/* <Col xl="3">
            <ClientLink id={this.props.match.params.id} clientId={this.props.match.params.clientId} />
              </Col> */}
              
            <Col xl="12">
            <Card className="border-full"> 
                      <CardBody>
                        <Row>
                          <Col sm="12">
                          {/* <h4 >Home Preferences</h4> */}
                          <table className="table table-striped">
                            <thead>
                              <tr>
                              
                              <th width={isResponsive ? "30%" : "20%" }>Name</th>
                              <th >Value</th>
                              <th></th>
                              </tr>
                            </thead>
                            <tbody>
                           
                                <tr>
                                  <td>Type of house</td>
                                  <td>{homeprefrences?.typeOfHouse || 'n/a'}</td>
                                  <td></td>
                                </tr> 
                                <tr>
                                  <td>City</td>
                                  <td>{homeprefrences?.city || 'n/a' }</td>
                                  <td></td>
                                </tr> 
                                <tr>
                                  <td>Min. price</td>
                                  <td>{homeprefrences?.minPrice ?  
                                    <CurrencyFormat
                                    value={homeprefrences?.minPrice}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={userdetail?.agentDefaultCurrencyCode + " "}
                                  /> : 'n/a' }</td>
                                  <td></td>
                                </tr> 
                                <tr>
                                  <td>Max price</td>
                                 
                                    <td>{homeprefrences?.maxPrice ?  
                                    <CurrencyFormat
                                    value={homeprefrences?.maxPrice}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={userdetail?.agentDefaultCurrencyCode + " "}
                                  /> : 'n/a' }</td>
                                  <td></td>
                                </tr> 
                                <tr>
                                  <td>Square feet</td>
                                  <td>{homeprefrences?.sqFeets || 'n/a'}</td>
                                  <td></td>
                                </tr> 
                                <tr>
                                  <td># BR</td>
                                  <td>{homeprefrences?.bedRoom || 'n/a' }</td>
                                  <td></td>
                                </tr> 
                                <tr>
                                  <td># of Bath</td>
                                  <td>{homeprefrences?.bathRoom || 'n/a'}</td>
                                  <td></td>
                                </tr> 
                                {this.state.addprefrences && this.state.addprefrences.map((homeprefrence, appoint) => (
                                  <tr key={"_app_" + appoint}>
                                  <td>{homeprefrence.clientAdditionalHomePreferenceTitle}</td>

                                  <td >{homeprefrence.clientAdditionalHomePreferenceDescription	}</td>
                                  <td></td>
                                  </tr>
                                ))}
                               
                                        
                            
                          
                              
                            </tbody>
                            </table>

                         
                        </Col>
                      </Row>
                    </CardBody>
                    </Card>

                 <h5 className={`mt-2 mb-2 card-title ${isResponsive ? 'p-2': '' }`}>Important Destinations</h5>                    
             <Card className="border-full"> 
                      <CardBody>
                        <Row>
                          <Col sm="12">
                          {/* <h4 >Home Preferences</h4> */}
                          <table className="table table-striped">
                            <thead>
                              <tr>
                              
                              <th width={isResponsive ? "30%" : "20%" }>Name</th>
                              <th >Address</th>
                              <th></th>
                              </tr>
                            </thead>
                            <tbody>
                           
                              
                                {this.state.importantDestinations && this.state.importantDestinations.map((destination, dest) => (
                                  <tr key={"_desct_" + dest}>
                                  <td>{destination.destinationTitle}</td>

                                  <td >{destination.destinationAddress}</td>
                                  <td></td>
                                  </tr>
                                ))}
                               
                                        
                            
                          
                              
                            </tbody>
                            </table>

                         
                        </Col>
                      </Row>
                    </CardBody>
                    </Card>
            </Col>
            
            </Row>
            </Col>
            </Row>
            ) : (
              <NoAccess />
             
            )}
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
ClientHomePref.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,
  history: PropTypes.object,
  onGetClientDetail:PropTypes.func,
  clietDetail: PropTypes.object,
  updateHomePref: PropTypes.func,
  postHomePref: PropTypes.func,
  userdetail:PropTypes.func,
  isResponsive:PropTypes.object


}

const mapStateToProps = ({ Clients }) => (
  {
    clietDetail: Clients.clietDetail,
    
   

  })

const mapDispatchToProps = dispatch => ({
  onGetClientDetail: clientId => dispatch(getClientDetail(clientId)),
  postHomePref: (payload, history) => dispatch(postHomePref(payload, history)),
  updateHomePref: (payload, history) => dispatch(updateHomePref(payload, history)),
 
});
export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(ClientHomePref))
